import { Logger } from '@ancon/wildcat-utils/logger'

import archiveLogStrategy from './archiveLogStrategy'

const archiveLogger = new Logger(archiveLogStrategy)

export default archiveLogger
